import { GetterTree } from 'vuex';

import { LessonsStateI } from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<LessonsStateI, RootStateI> = {
};
